// extracted by mini-css-extract-plugin
export default {"accordionTitle":"DetailsAccordian_accordionTitle__lGqXR","accordionIcon":"DetailsAccordian_accordionIcon__xUcgX"};